import type { NavigationGuard } from 'vue-router';
import { usePB } from '@/composables/database/use-pocket-base.ts';
import { UsersModerationRoleOptions, type UsersRecord } from '@/types/pocketbase-types.ts';

export const adminGuard: NavigationGuard = (to) => {
  const pb = usePB();
  if (!pb.isLoggedIn.value) return { path: '/auth', query: { redirectUrl: to.fullPath } };
  if ((pb.currentUser.value as UsersRecord | undefined)?.moderation_role !== UsersModerationRoleOptions.admin) return { path: '/events' };
};
